export default {
    state: {
        pageTitle: "Cutiefyme",
        isFooterContactsShown: true,
    },
    
    mutations: {
        SET_TITLE(state, title) {
            state.title = title;
            document.querySelector("head title").innerHTML = state.title;
        },
        SET_SHOW_FOOTER_CONTACTS(state, show = true) {
            state.isFooterContactsShown = show;
        }

    },
    actions: {
        setTitle(context, title) {
            context.commit("SET_TITLE", `Cutiefyme - ${ title }`);
        },
        resetTitle(context) {
            context.commit("SET_TITLE", "Cutiefyme");
        },
        showFooterContacts(context, show = true) {
            context.commit("SET_SHOW_FOOTER_CONTACTS", !!show);
        },
    },
    getters: {
        isFooterContactsShown(context) {
            return context.isFooterContactsShown;
        }
    }
};
